"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const noop_1 = __importDefault(require("lodash/noop"));
const next_i18next_1 = require("next-i18next");
const router_1 = require("next/router");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Yup = __importStar(require("yup"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const graphql_types_1 = require("@hotelplan/graphql.types");
const libs_auth_next_1 = require("@hotelplan/libs.auth-next");
const libs_cross_login_1 = require("@hotelplan/libs.cross-login");
const libs_login_redirect_1 = require("@hotelplan/libs.login-redirect");
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const FailureLoginErrorMessage = styled_components_1.default.p(({ theme }) => theme.auth.errorMessage);
const LoginForm = styled_components_1.default.form(({ theme }) => theme.auth.loginForm);
const B2CLoginValidationSchema = Yup.object({
    username: Yup.string()
        .required('forms:errors.email.required')
        .matches(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i, 'forms:errors.email.format'),
    password: Yup.string().required('forms:errors.password.required'),
});
const B2CLoginForm = props => {
    const { query } = (0, router_1.useRouter)();
    const { onLogin = noop_1.default, redirectPageType = graphql_types_1.PageType.MyaccountMybookings, } = props;
    const [t, { language }] = (0, next_i18next_1.useTranslation)(['forms', 'myaccount']);
    const [error, setError] = (0, react_1.useState)(false);
    const { client } = (0, libs_auth_next_1.useAuthContext)();
    const redirectRoute = (0, react_1.useMemo)(() => (0, libs_router_config_1.getRouteByPageTypeLocale)(redirectPageType, language), [language, redirectPageType]);
    const onSubmit = (values, helpers) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { error: isError } = yield client.login(values);
            if (!isError) {
                onLogin();
                let redirectionHref = redirectRoute.builder({});
                const redirectUrlQueryParam = (0, libs_login_redirect_1.getRedirectQueryParamFromQuery)(query);
                if (redirectUrlQueryParam) {
                    const internalRedirectRoute = (0, libs_router_config_1.getRouteByLangId)(redirectUrlQueryParam.value, language);
                    if (internalRedirectRoute) {
                        redirectionHref = internalRedirectRoute.builder({});
                    }
                }
                const callbackUrlQueryParam = (0, libs_cross_login_1.getCallbackUrlQueryParamFromQuery)(query);
                if (callbackUrlQueryParam) {
                    redirectionHref = `${libs_auth_next_1.SSR_B2C_CROSS_LOGIN_ENDPOINT_PATH}?${callbackUrlQueryParam.name}=${callbackUrlQueryParam.value}`;
                }
                window.location.href = redirectionHref;
            }
            else {
                setError(true);
            }
        }
        catch (e) {
            setError(true);
        }
        finally {
            helpers.resetForm();
        }
    });
    return (react_1.default.createElement(formik_1.Formik, { initialValues: {
            username: '',
            password: '',
        }, onSubmit: onSubmit, validationSchema: B2CLoginValidationSchema }, formik => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            error && (react_1.default.createElement(FailureLoginErrorMessage, null, t('myaccount:login.error'))),
            react_1.default.createElement(LoginForm, { noValidate: true, onSubmit: (e) => formik.handleSubmit(e) },
                react_1.default.createElement("div", { className: "text-input" },
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "username", label: t('myaccount:email.label'), type: "email", autoComplete: "email", autoCorrect: "off", autoCapitalize: "none", showErrorMessage: true })),
                react_1.default.createElement("div", { className: "text-input" },
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "password", type: "password", autoComplete: "current-password", label: t('forms:password.label'), showErrorMessage: true })),
                react_1.default.createElement(components_common_buttons_1.Button, { disabled: formik.isSubmitting, type: "submit", className: "login-form-submit" }, t('myaccount:login.button')))));
    }));
};
exports.default = B2CLoginForm;
//# sourceMappingURL=B2CLoginForm.js.map